import { useQuery } from 'react-query';
import { getAllResponsiblesForSelectionAsync } from '../../index';

export const RESPONSIBLE_KEYS = {
  ALL: 'responsibles',
  SELECTION: 'selection',
};

export const useGetAllResponsiblesForSelectionQuery = () => {
  return useQuery(
    [RESPONSIBLE_KEYS.ALL, RESPONSIBLE_KEYS.SELECTION],
    async () => {
      return getAllResponsiblesForSelectionAsync();
    },
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60,
    }
  );
};